// extracted by mini-css-extract-plugin
export default {"main":"GExpandDialog-module_main_e0047a55","content":"GExpandDialog-module_content_d14d901d","expand":"GExpandDialog-module_expand_ed9369c4"};